<div class="flex w-3xs flex-col gap-2" *transloco="let t">
    <span class="text-primary font-serif font-bold">{{ t('Theme') }}</span>
    <p-select-button [options]="availableThemes" [(ngModel)]="currentTheme" styleClass="!w-full" optionValue="theme">
        <ng-template #item let-item>
            <svg [lucideIcon]="item.icon"></svg>
        </ng-template>
    </p-select-button>
    <p-splitter />
    <span class="text-primary font-serif font-bold">{{ t('Language') }}</span>
    <p-select-button
        [options]="languages()"
        [(ngModel)]="language"
        [disabled]="true"
        optionLabel="text"
        optionValue="value"
        styleClass="!w-full" />
    <p-splitter />
    <span class="text-primary font-serif font-bold">{{ t('Information') }}</span>
    @if (hasServiceNow()) {
        <button pButton class="!w-full" variant="text" severity="secondary" (click)="openServiceNow()">
            <svg [lucideIcon]="ServiceNowIcon" class="text-neutral-600 dark:text-white"></svg>
            <span class="mt-1 mr-auto font-bold text-neutral-600 dark:text-white">
                {{ t('AdvaniaSupportPortal') }}
            </span>
        </button>
    }
    <button pButton class="!w-full" variant="text" severity="secondary" (click)="openContactUs()">
        <svg [lucideIcon]="ContactUsIcon" class="text-neutral-600 dark:text-white"></svg>
        <span class="mt-1 mr-auto font-bold text-neutral-600 dark:text-white">
            {{ t('ContactUs') }}
        </span>
    </button>
    <button pButton class="!w-full" variant="text" severity="secondary" (click)="toggleGdpr()">
        <svg [lucideIcon]="GdprIcon" class="text-neutral-600 dark:text-white"></svg>
        <span class="mt-1 mr-auto font-bold text-neutral-600 dark:text-white">
            {{ t('GdprCommitment') }}
        </span>
    </button>
    <p-splitter />
    <button pButton (click)="signOut()" class="!w-full">
        <span class="mt-1 mr-auto font-bold">{{ t('SignOut') }}</span>
        <svg [lucideIcon]="LogOutIcon" class="text-neutral-600 dark:text-white"></svg>
    </button>
    <span class="items-end-safe text-right text-neutral-500 dark:text-neutral-400">
        {{ t('Version') }}: {{ version }}
    </span>
</div>
